import * as React from 'react';
import styled from 'styled-components';
import { IA2AccountDropdownTrigger } from './components/AccountDropdown/IA2AccountDropdownTrigger';
import { CentricAccountDropdownTrigger } from './components/AccountDropdown/CentricAccountDropdown/CentricAccountDropdownTrigger';
import { useIsFeatureEnabled } from 'src/commons/hooks';
import { WeblabedFeatures } from 'src/commons/constants';

const MobileAccountSwitcherSectionContainer = styled.div`
  background: ${({ theme }) => theme.header.contextBar.background};
  padding: 0 16px 16px;
`;

export const MobileAccountSwitcherSection: React.FC<{
  handleToggle: () => void;
}> = ({ handleToggle }) => {
  const centricAccountSwitcherEnabled = useIsFeatureEnabled(
    WeblabedFeatures.CENTRIC_MIGRATION_T2,
  );
  return (
    <MobileAccountSwitcherSectionContainer>
      {centricAccountSwitcherEnabled ? (
        <CentricAccountDropdownTrigger
          handleToggle={handleToggle}
          isOpen={false}
        />
      ) : (
        <IA2AccountDropdownTrigger handleToggle={handleToggle} isOpen={false} />
      )}
    </MobileAccountSwitcherSectionContainer>
  );
};
